import { Viewer, Worker } from '@react-pdf-viewer/core'

export function PDFViewer({ file }) {
  return (
    <div className='w-full'>
      <Worker workerUrl='https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js'>
        <Viewer fileUrl={file} />
      </Worker>
    </div>
  )
}